import { useProductRecommendation } from "./hooks/hooks/use-product-recommendation.js";
export {
  useProductRecommendation
};
//# sourceMappingURL=index.js.map
